import React from "react";
import styles from "./pdpStatusBar.scss";

function PdpStatusBar({ message, url }) {
  if (!message) return null;
  return (
    <div className={styles["product_arrival_wrapper"]}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.55859 0.25C4.27734 0.25 0.808594 3.75 0.808594 8C0.808594 12.2812 4.27734 15.75 8.55859 15.75C12.8086 15.75 16.3086 12.2812 16.3086 8C16.3086 3.75 12.8086 0.25 8.55859 0.25ZM8.55859 14.25C5.08984 14.25 2.30859 11.4688 2.30859 8C2.30859 4.5625 5.08984 1.75 8.55859 1.75C11.9961 1.75 14.8086 4.5625 14.8086 8C14.8086 11.4688 11.9961 14.25 8.55859 14.25ZM8.55859 3.6875C7.80859 3.6875 7.24609 4.28125 7.24609 5C7.24609 5.75 7.80859 6.3125 8.55859 6.3125C9.27734 6.3125 9.87109 5.75 9.87109 5C9.87109 4.28125 9.27734 3.6875 8.55859 3.6875ZM10.3086 11.625V10.875C10.3086 10.6875 10.1211 10.5 9.93359 10.5H9.55859V7.375C9.55859 7.1875 9.37109 7 9.18359 7H7.18359C6.96484 7 6.80859 7.1875 6.80859 7.375V8.125C6.80859 8.34375 6.96484 8.5 7.18359 8.5H7.55859V10.5H7.18359C6.96484 10.5 6.80859 10.6875 6.80859 10.875V11.625C6.80859 11.8438 6.96484 12 7.18359 12H9.93359C10.1211 12 10.3086 11.8438 10.3086 11.625Z"
          fill="#2C2C2C"
        />
      </svg>
      <span className={styles["arrival-info"]}>
        {message}
        {url && (
          <a
            className={styles.viewMore}
            target="_blank"
            href={url}
            rel="noreferrer"
          >
            詳情
          </a>
        )}
      </span>
    </div>
  );
}

export default PdpStatusBar;
